module.exports = __webpack_public_path__ + "static/media/initialOval.0e075af8.png";